var MediaBlock = function(template, media, selector) {

  this.sel = (function(selector) {
    return $(this.SELECTOR + (selector ? (' ' + selector) : ''));
  }).bind(this);

  this.updateModel = (function() {}).bind(this);

  this.addEvents = (function() {}).bind(this);

  this.render = (function() {
    var rendered = this._TEMPLATE(this.MEDIA);
    this.sel().html(rendered);
    this.addEvents();
  }).bind(this);

  this._TEMPLATE = template;
  this.MEDIA = media;
  this.SELECTOR = selector;
};
